/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_ResolveInputs */

const en_directory_submit_enrich_stage_resolve = /** @type {(inputs: Directory_Submit_Enrich_Stage_ResolveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry URL`)
};

const zh_directory_submit_enrich_stage_resolve = /** @type {(inputs: Directory_Submit_Enrich_Stage_ResolveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解析入口`)
};

/**
* | output |
* | --- |
* | "Entry URL" |
*
* @param {Directory_Submit_Enrich_Stage_ResolveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_resolve = /** @type {((inputs?: Directory_Submit_Enrich_Stage_ResolveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_ResolveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_resolve(inputs)
	return zh_directory_submit_enrich_stage_resolve(inputs)
});
export { directory_submit_enrich_stage_resolve as "directory.submit.enrich.stage.resolve" }